/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import ButtonComponent from "../../components/ButtonMC";
import InputComponent from "../../components/InputMC";
import ButtonIconMC from "../../components/ButtonIconMC";
import { v4 as uuidv4 } from 'uuid';

const ReasonsForClosure = ({
  reasonsForClosure,
  setReasonsForClosure
}) => {
  const { t } = useTranslation('Funnels');
  const iconColor = reasonsForClosure.length > 1 ? 'tw-text-gray-500' : 'tw-text-gray-300';

  const handleChange = (id, value) => {
    const newReasons = reasonsForClosure.map((reason) => (reason.id === id ? { ...reason, reason: value } : reason));
    setReasonsForClosure(newReasons);
  };

  const addReason = () => {
    setReasonsForClosure([...reasonsForClosure, { id: uuidv4(), reason: '', _created: true }]);
  };

  const removeReason = (reason) => {
    if (reasonsForClosure.length === 1) return;

    setReasonsForClosure([{ ...reason, _destroy: true }, ...reasonsForClosure.filter((r) => r.id !== reason.id)]);
  };

  useEffect(() => {
    if (reasonsForClosure.length === 0) {
      setReasonsForClosure([{ id: uuidv4(), reason: '', _created: true }]);
    }
  }, [reasonsForClosure]);

  return (
    <>
      {reasonsForClosure.filter(({ _destroy }) => !_destroy ).map((reason, index) => (
        <div key={`${reason.id}`} className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-mb-2">
          <InputComponent
            value={reason.reason}
            onChange={(key, value) => handleChange(reason.id, value)}
            name={`reason_${reason.id}`}
            secondaryLabel={`${t('sidebar.createFromZero.stageClosed.fields.reason.inputLabel')} ${
              index + 1
            }`}
            placeholder={`${t('sidebar.createFromZero.stageClosed.fields.reason.placeholder')} ${
              index + 1
            }`}
            className="tw-resize-none"
            containerClass="tw-w-full"
            useFloatingAndNonFloatingLabel
          />
          <ButtonIconMC
            icon="trash-2-outline"
            label={t('sidebar.createFromZero.stageClosed.fields.reason.delete')}
            onClick={() => {
              if (window.confirm(t('sidebar.createFromZero.stageClosed.fields.reason.confirmDelete'))) {
                removeReason(reason);
              }
            }}
            iconClassName={iconColor}
          />
        </div>
      ))}

      <ButtonComponent
        text={t('sidebar.createFromZero.stepTwo.addButton')}
        variant="SECONDARY"
        className="tw-pl-2"
        iconPosition="left"
        icon="plus-outline"
        onClick={addReason}
      />
    </>
  );
};

export default ReasonsForClosure;
